module.exports = __webpack_public_path__ + "static/media/tick-green-filled.bb969a14.svg";